import React from 'react'
import {Header, Container, Icon, Button, Divider} from 'semantic-ui-react'
import SidebarComponent from "../layout/SidebarComponent"
import styles from "../glossary/sidebar.module.scss"
import useSWR  from 'swr'
import {fieldNames} from "./options";
import {getSortStatusName} from "../glossary/options"
import {AppFetcher} from "../../fetch/application";


const SidebarPanel = ({ visible, item, close, edit, handleDialogVisibility, handleFlowVisibility, openDialogCreation }) => {

    const { data : contentList, errorContent } = useSWR(((item === null)) ? null : `/endpoint/data-content/list/${item.schedule.id}`, AppFetcher, { errorRetryCount: 2 })

    return (
        <SidebarComponent visible={visible}>
            <Container as="div" className={styles.containerMenu}>
                <Icon name="pencil"  onClick={edit} className={styles.pointer}/>
                &nbsp;
                <Icon name="close" onClick={close} className={styles.pointer}/>
            </Container>

            <Header as="h3" className={styles.marginB30}>
                Details
            </Header>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.status.toUpperCase()}</p>
                <p>{getSortStatusName(item.status)}</p>
            </div>
            {item.description && <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.description.toUpperCase()}</p>
                <p>{item.description}</p>
            </div>}

            {item.report &&
                <div>
                    <div className={styles.marginB30}>
                        <p className={styles.pH1}>REPORT</p>
                        <p className={styles.pH2}>{fieldNames.name.toUpperCase()}: {item.report.name}</p>
                        <p className={styles.pH2}>{fieldNames.status.toUpperCase()}: {getSortStatusName(item.report.status)}</p>
                        <p className={styles.pH2}>{fieldNames.definition.toUpperCase()}: {item.report.definition}</p>
                    </div>
                </div>
            }

            {item.schedule &&
                <div>
                    <div className={styles.marginB30}>
                        <p className={styles.pH1}>SCHEDULE</p>
                        <p className={styles.pH2}>{fieldNames.name.toUpperCase()}: {item.schedule.name}</p>
                        <p className={styles.pH2}>{fieldNames.status.toUpperCase()}: {getSortStatusName(item.schedule.status)}</p>
                        <p className={styles.pH2}>{fieldNames.definition.toUpperCase()}: {item.schedule.definition}</p>
                    </div>
                </div>
            }
            <div className={styles.marginB30}>
                <p className={styles.pH1}>ATTRIBUTES</p>
                {item.attributes && item.attributes.map((attribute, i) => {
                    return <div key={i}>
                        <div className={styles.marginB30}>
                            <p className={styles.pH2}>{fieldNames.name.toUpperCase()}: {attribute.name}</p>
                            <p className={styles.pH2}>{fieldNames.status.toUpperCase()}: {getSortStatusName(attribute.status)}</p>
                            <p className={styles.pH2}>{fieldNames.definition.toUpperCase()}: {attribute.definition}</p>
                        </div>
                        {/*(i < item.attributes.length-1) && <hr />*/}
                    </div>
                })}
            </div>

            <Divider horizontal>Data Content</Divider>

            {contentList && contentList.data &&
            contentList.data.map( (content, i) => {
                return <div key={i}
                            onClick={(e) => handleDialogVisibility(content)}
                            className={styles.dataContent}>
                    <span>{content.name}</span>
                </div>
            })}
            <div>
                <Button onClick={()=> handleDialogVisibility(null, false) }>
                    <Icon style={{marginRight: '10px'}} name="plus" />
                    Add new Data Content
                </Button>
            </div>

        </SidebarComponent>

    )
}

export default SidebarPanel